// Produktet Frame tani ruhen në Supabase database
export const productsFrame = [];
